import { useCallback, useEffect, useState } from "react";
import Inputs from "./Inputs";
import { packageTypes, receivingRegions } from "../../../data/static-data";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../alerts/alertSlice";
import OverPrice from "./OverPrice";
import { authAPI } from "../../../api/auth/auth";
import { adminPricesApi } from "../../../api/admin/prices";
import CreateOverPrice from "./CreateOverPrice";
import GreenSpinner from "../../../components/loaders/GreenSpinner";

const OverPrices = () => {
    const dispatch = useDispatch();
    const [regionID, setRegionID] = useState(receivingRegions[0].value);
    const [packageType, setPackageType] = useState(packageTypes[0].value);
    const [senderCityWithOfficeID, setSenderCityWithOfficeID] = useState(1);

    const [prices, setPrices] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    const uploadData = useCallback(
        async function () {
            if (!regionID || !packageType || !senderCityWithOfficeID) return;

            setIsUploading(true);
            const resp = await adminPricesApi.getOverPrices(
                regionID,
                packageType,
                senderCityWithOfficeID
            );
            setIsUploading(false);

            if (!resp.ok) {
                dispatch(
                    pushAlert({
                        message: resp.err,
                        delay: 1000,
                        type: "danger",
                    })
                );

                return;
            }

            setPrices(resp.overPrices);
        },
        [regionID, packageType, senderCityWithOfficeID, dispatch]
    );

    useEffect(() => {
        uploadData();
    }, [uploadData]);

    const [focusedInputIndex, setFocusedInputIndex] = useState(null);

    return (
        <div className="p-5">
            <h1 className="text-left text-xl font-bold">
                Key Codes:
                <span className="text-red-500"> 1:</span>{" "}
                <span className="text-gray-800">
                    {" "}
                    Enter - move to next input
                </span>
                <span className="text-red-500"> 2:</span>{" "}
                <span className="text-gray-800">
                    {" "}
                    Shift + Enter - move to previous input
                </span>
            </h1>
            <Inputs
                regionID={regionID}
                setRegionID={setRegionID}
                packageType={packageType}
                setPackageType={setPackageType}
                senderCityWithOfficeID={senderCityWithOfficeID}
                setSenderCityWithOfficeID={setSenderCityWithOfficeID}
            />

            <hr className="border-black my-10" />

            <div className="mb-6">
                <CreateOverPrice
                    reloadOverPrices={uploadData}
                    regionID={regionID}
                    packageType={packageType}
                    senderCityWithOfficeID={senderCityWithOfficeID}
                />
            </div>

            {isUploading && (
                <div className="text-center text-2xl font-bold">
                    <GreenSpinner />
                </div>
            )}

            {!isUploading && (
                <>
                    <table className="table-auto w-full">
                        <thead className="">
                            <tr>
                                <th className="border-2 p-3 border-emerald-600">
                                    Weight kg
                                </th>
                                <th
                                    className="border-2 p-3 border-emerald-600"
                                    style={{ maxWidth: "100px" }}
                                >
                                    Price<b> $</b>
                                </th>
                                {/* <th className="border-2 p-3 border-emerald-600">
                                            Delete
                                        </th> */}
                                <th className="border-2 p-3 border-emerald-600">
                                    Save
                                </th>

                                <th className="border-2 p-3 border-emerald-600">
                                    Delete
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {prices.map((price, idx) => (
                                <OverPrice
                                    key={price.id}
                                    price={price}
                                    setPrice={(newPrice) =>
                                        setPrices((prev) =>
                                            prev.map((p) => {
                                                if (p.id === price.id) {
                                                    return newPrice;
                                                }
                                                return p;
                                            })
                                        )
                                    }
                                    focused={focusedInputIndex === idx}
                                    focusToNextInput={() => {
                                        setFocusedInputIndex(idx + 1);
                                    }}
                                    focusToPrevInput={() => {
                                        setFocusedInputIndex(idx - 1);
                                    }}
                                    refreshOverPrices={uploadData}
                                />
                            ))}
                        </tbody>
                    </table>

                    {(!prices || prices.length === 0) && (
                        <span className="block text-center font-medium text-xl mt-4">
                            No over prices found for this type of package{" "}
                        </span>
                    )}
                </>
            )}
        </div>
    );
};

export default OverPrices;
